import React, { memo } from 'react';
import documentationData from '../../data/documentationData';

const DocNavigation = memo(function DocNavigation({
  activeSectionId,
  activeSubsectionId,
  expandedSections,
  onSectionClick,
  onSectionNavigate,
  onSubsectionNavigate
}) {
  return (
    <nav className="docs-nav">
      {documentationData.sectionOrder.map(sectionId => {
        const section = documentationData.sections[sectionId];
        const isActive = activeSectionId === sectionId;
        const isExpanded = expandedSections[sectionId];
        
        return (
          <div key={sectionId} className="docs-nav-section">
            <div
              className={`docs-nav-section-title ${isActive ? 'active' : ''}`}
              onClick={() => {
                onSectionClick(sectionId);
                onSectionNavigate(sectionId);
              }}
            >
              {section.title}
              <span className={`section-arrow ${isExpanded ? 'expanded' : ''}`}>
                ›
              </span>
            </div>
            
            <ul className={`docs-nav-subsections ${isExpanded ? 'visible' : ''}`}>
              {Object.values(section.subsections)
                .sort((a, b) => a.order - b.order)
                .map(subsection => (
                  <li key={`nav-${sectionId}-${subsection.id}`}>
                    <a
                      href={`#s=${sectionId}&ss=${subsection.id}`}
                      className={isActive && activeSubsectionId === subsection.id ? 'active' : ''}
                      onClick={(e) => {
                        e.preventDefault();
                        onSubsectionNavigate(sectionId, subsection.id);
                      }}
                    >
                      {subsection.title}
                    </a>
                  </li>
                ))}
            </ul>
          </div>
        );
      })}
    </nav>
  );
});

export default DocNavigation;